
import dayjs from 'dayjs'
import ulog from 'ulog'
import { setTimeout } from 'timers'
import utils from './utils'

const voces = []

const utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

const RECONNECT_DEFAULT_SECS = 5

const log = ulog('protocol')

const today = function () {
  return dayjs().format('YYYY-MM-DD HH:mm:ss')
}

const time = function () {
  return dayjs().format('HH:mm')
}

let closing = false
export default class Protocol {
  /**
     *
     * Constructor e Inicializador
     *
     */
  constructor (view, setup) {
    // this de channel
    const _p = this
    // Referencias
    utils.setCookieMode(setup.cookie_mode === 'cookie')
    this.view = view
    this.setup = setup

    // Permite el envio de mensajes si esta en true, sino ignorar
    this.enableChat = true
    // Estado de la comunicacion, no deberia enviarse mensajes en false
    this.networkStatus = false
    // Pregunta formulario login
    this.loginForm = false
    this.my = {
      name: 'Visita',
      email: '',
      telefono: ''
    }

    this.reconnectSecs = RECONNECT_DEFAULT_SECS
    // log
    log.level = this.setup.log_level || 2
    log.level = log.TRACE

    // ####### Cookie Session ID: #######
    const cookieSessionId = utils.getCookie('gb-wbchtbt-ssid')
    let resetCookie = false
    if (this.setup.session_id) {
      if (!cookieSessionId || cookieSessionId !== this.setup.session_id) {
        if (this.setup.style && this.setup.style === '507f191e810c19729de860ea') {
          const _nc = this.setup.session_id.split(';')
          const _ac = cookieSessionId.split(';')
          if (_nc[1] !== _ac[1] && _nc[2] !== _ac[2]) {
            utils.setCookie('gb-wbchtbt-ssid', this.setup.session_id, 365)
            resetCookie = true
          }
        } else {
          utils.setCookie('gb-wbchtbt-ssid', this.setup.session_id, 365)
          resetCookie = true
        }
      }
    } else {
      utils.setCookie('gb-wbchtbt-ssid', '', 365)
      if (this.setup.session_id === '' && this.setup.session_id !== cookieSessionId) {
        resetCookie = true
      }
    }
    // ####### Cookie Session ID: #######

    // Cookie
    let cookie = utils.getCookie('gb-wbchtbt-uid')
    log.info('GB Chat UID', cookie)
    if (resetCookie === true || cookie === '' || cookie === null) {
      cookie = utils.ObjectId()
      utils.setCookie('gb-wbchtbt-uid', cookie, 365)
      log.info('GB Chat UID NEW', cookie)
    }

    // Revisa Auto Close
    this.lastActivity = (new Date()).getTime()
    setInterval(function () {
      _p.eventAutoClose()
    }, 10000)

    // Revisa Launcher ChatbotOff
    setInterval(function () {
      if (sessionStorage.getItem('chatbotOff') && JSON.parse(sessionStorage.getItem('chatbotOff')).secondsOff > 0) {
        _p.eventChatbotOffDisplay()
      }
    }, 10000)

    // Evento cierre ventana
    window.addEventListener('beforeunload', function () {
      log.info('GB: close')
    })
    // debug
    window.protocol = this
    this.chatOpenedByProactive = false
    this.chatOpenedByProactiveInmediate = false
    this.chatOpenedByEvent = false
    this.messageOpenedByEvent = false
    // Path Actual
    this.url = ''
    // Contexto para IA
    this.urlContext = false
    // Tiempo de mensajes
    this.lastMessageTime = dayjs()
    // Tiempo de interaccion
    this.lastInteractionWithPage = dayjs()
  }

  /**
   * Start Event
   */
  onStart () {
    const _p = this
    log.info('GB: onStart')
    this.view.setEmbedded(!!this.setup.embedded)
    // Auto abre aventana
    const isOpenChat = utils.getCookie('gb-wbchtbt-isopen')
    const isOpenChatMinimize = utils.getCookie('gb-wbchtbt-minimize')
    if (isOpenChat === 'true' || this.setup.embedded) {
      this.view.openChat()
    } else if (isOpenChatMinimize === 'true') {
      this.view.openChatMinimize()
    }
    // Revisa estado del canal
    log.info('GB:  Channel check')
    const websocket = new WebSocket(_p.setup.websocket_url)
    websocket.onopen = function () {
      if (websocket) {
        websocket.send(JSON.stringify({
          type: _p.setup.type,
          channel: _p.setup.channel,
          session_id: _p.setup.session_id
        }))
      }
    }
    websocket.onmessage = function (evt) {
      const datos = JSON.parse(evt.data)
      const isOpenChatMinimize = utils.getCookie('gb-wbchtbt-minimize')
      if (datos.channel && datos.channel.datos && datos.channel.datos.channel && datos.channel.datos.channel.plugin_chat_abierto && !isOpenChatMinimize) _p.eventchatOpened()
      if (datos.type === 'config') {
        if (datos.channel.verticalLauncherEnabled) _p.view.setDisplayVerticalLauncher(datos.channel.verticalLauncherEnabled)
        if (datos.channel.custom_avatars_plugin_enabled && datos.channel.plugin_custom_avatars && datos.channel.plugin_custom_avatars.length > 0) {
          const enabledAvatars = datos.channel.plugin_custom_avatars.filter(avatar => avatar.enabled)
          if (enabledAvatars.length > 0) _p.view.setCustomAvatarAssistans(enabledAvatars)
        }
        if (datos.channel.plugin_custom_placeholders && datos.channel.plugin_custom_placeholders.length > 0) {
          _p.view.setCustomPlaceholders(datos.channel.plugin_custom_placeholders)
          _p.view.setInputText(true)
        }
        if (datos.channel.plugin_enable_microphone) {
          _p.view.setEnabledMicrophone(datos.channel.plugin_enable_microphone)
        }
        _p.view.enabled_info = datos.channel.plugin_enabled_info
        _p.view.isChannelEnabled = datos.channel.enabled
        if (_p.view.enabled_info) { _p.view.ai_generative_enabled = datos.channel.ai_generative_enabled }
        if (datos.channel.closeLauncherEnabled) {
          _p.view.enabledCloseBtn = datos.channel.closeLauncherEnabled
          _p.view.timeCloseBtn = datos.channel.timecloseLauncher
        }
        const screenWidthOpenPlugin = window.innerWidth
        if (datos.channel.plugin_chat_abierto && !isOpenChatMinimize && screenWidthOpenPlugin > 576) _p.view.openChat()
        if (datos.channel.custom_webchat_messages) {
          _p.url = window.location.href
          const matchedCustomWebchatMessage = datos.channel.custom_webchat_messages.find((customWelcomeMessage) => { return _p.url.includes(customWelcomeMessage.url) })
          const customWebchatMessages = matchedCustomWebchatMessage
          let messageDate = dayjs().utc()
          messageDate = messageDate.utcOffset(dayjs().utcOffset()).format('HH:mm')
          if (customWebchatMessages && customWebchatMessages.messages) {
            if (customWebchatMessages.plugin_custom_placeholders && customWebchatMessages.plugin_custom_placeholders.length > 0) {
              _p.view.setCustomPlaceholders(customWebchatMessages.plugin_custom_placeholders)
              _p.view.setInputText(true)
            }
            const operadores = ['=', '>', '<', '<=', '>=']
            customWebchatMessages.messages.forEach((message) => {
              if (message.type === 'proactive') {
                setTimeout(() => {
                  const isOpenChat = utils.getCookie('gb-wbchtbt-isopen')
                  const isMinimized = utils.getCookie('gb-wbchtbt-minimize')
                  if (isOpenChat === 'false' || isOpenChat === '') {
                    if (message.time === 0) {
                      _p.chatOpenedByProactiveInmediate = true
                      _p.view.openChat()
                    } else {
                      _p.chatOpenedByProactive = true
                      _p.view.openChat()
                      if (isMinimized === 'true') _p.processCustomMessage(message)
                    }
                  } else {
                    clearTimeout()
                  }
                }, (message.time * 1000))
              }
              if (message.type === 'event') {
                message.tags.forEach(tag => {
                  const element = document.getElementById(tag.id)
                  if (element) {
                    element.addEventListener(tag.event, () => {
                      if (tag.condition !== '') {
                        const operator = operadores.find(op => { return tag.condition.includes(op) })
                        const operatorIndex = tag.condition.indexOf(operator)
                        const condition = utils.logicalOperator(element.value, tag.condition.substring(operatorIndex + 1), operator)
                        if (condition) {
                          setTimeout(() => {
                            this.chatOpenedByEvent = true
                            this.messageOpenedByEvent = message
                            _p.processCustomEventMessage(message, customWebchatMessages.time_between_events, messageDate)
                          }, message.time * 1000)
                        }
                      } else {
                        setTimeout(() => {
                          this.chatOpenedByEvent = true
                          this.messageOpenedByEvent = message
                          _p.processCustomEventMessage(message, customWebchatMessages.time_between_events, messageDate)
                        }, message.time * 1000)
                      }
                    })
                  }
                })
              }
            })
          }
        }
        const data = sessionStorage.getItem('formOpen')
        if (datos.channel.plugin_enabled_input_name && !_p.setup.session_id && !data) {
          // _p.view.setCurrentForm('Login', { requerido: _p.channel.plugin_required_input_name, formMessage: _p.channel.plugin_message_login_form })
          _p.view.setCurrentForm('Login',
            {
              channelData: datos.channel,
              requerido: datos.channel.plugin_required_input_name,
              formMessage: datos.channel.plugin_message_login_form,
              formName: datos.channel.plugin_show_name,
              formMail: datos.channel.plugin_show_mail,
              formFone: datos.channel.plugin_show_fone,
              requeridoName: datos.channel.plugin_required_name,
              requeridoMail: datos.channel.plugin_required_mail,
              requeridoFone: datos.channel.plugin_required_fone
            })
          // return
        } else if (datos.channel.plugin_chat_abierto) {
          _p.view.openChat()
        }
        websocket.close(3001)
      }
    }
  }

  /**
     *
     * Logica para reemplaza de tags
     *
     */
  fnReplaceTags (_p, str) {
    return str.replace('{NOMBRE_ASISTENTE}', _p.view.avatar.name)
  }

  /**
     *
     * Logica para manejo eventos desde boton
     *
     */
  fnButtonEventGeneric (_p, contextMsg, evt) {
    if (contextMsg.processClick === false) {
      return
    }
    let win
    // contextMsg.processClick = false; /* Segunda vez se vuelve solo lectura para cualquier boton */
    if (evt.type === 'text') {
      _p.eventMsgTx(evt.label, evt.args[0], false)
    } else if (evt.type === 'url') {
      win = window.open(evt.args[0], '_blank')
      if (win) {
        win.focus()
      } else {
        _p.view.addChatSystem(today(), 'No tienes habilitada ventanas emergentes en el sitio')
      }
    } else if (evt.type === 'url-self') {
      win = window.open(evt.args[0], '_self')
      if (win) {
        win.focus()
      } else {
        _p.view.addChatSystem(today(), 'No tienes habilitada ventanas emergentes en el sitio')
      }
    } else if (evt.type === 'video') {
      if (!utils.isSmallDevice() && evt.args[0].includes('embed')) {
        _p.view.showModal('<div style="  width: 16px;  position: absolute;  padding: 10px;  float: right;  z-index: 2;  cursor: pointer;  right: 5px;" onclick="window.protocol.view.hideModal()"><img style="position: relative;width: 20px; margin-left:-10px" src="https://biceqa.gatblac.com/static/multimedia/iconos/botones/close.png"></div><div style="position: relative;padding-bottom: 56.25%; padding-top: 25px; height: 0;"><iframe style="	position: absolute; top: 0; left: 0; width: 100%; height: 100%;" frameborder="1" scrolling="yes" marginheight="3" marginwidth="3" width="100%" height="690" type="text/html" src="' + evt.args[0] + '"></iframe></div>', {
          width: '640',
          height: '480px'
        })
      } else {
        const winV = window.open(evt.args[0], '_blank')
        if (winV) {
          winV.focus()
        } else {
          _p.view.addChatSystem(today(), 'No tienes habilitada ventanas emergentes en el sitio')
        }
      }
    } else if (evt.type === 'showExternalContent') {
      _p.view.showModal('<div style="  width: 16px;  position: absolute;  padding: 10px;  float: right;  z-index: 2;  cursor: pointer;  right: 5px;" onclick="window.protocol.view.hideModal()"><img style="position: relative;width: 20px; margin-left:-10px" src="https://biceqa.gatblac.com/static/multimedia/iconos/botones/close.png"></div><div style="position: relative;            padding-top: 56.25%; overflow: hidden;"><iframe style="	position: absolute; border: 0; left: 0; top:0; width: 100%; height: 100%;" frameborder="1" scrolling="yes" width="100%" height="" type="text/html" src="' + evt.args[0] + '"></iframe></div>', {
        width: '640',
        height: '480px'
      })
    } else {
      log.error('GB: Unknow action', evt)
    }
  }

  /**
     *
     * Mensaje Slider Inline
     *
     */
  renderSliderButton (ts, commin, readonly = false) {
    const _p = this
    const data = commin.content
    const sliders = []
    for (let i = 0; i < data.length; i++) {
      sliders.push({})
      sliders[i].image = data[i].image
      sliders[i].clickeable_img = data[i].clickeable_img ? data[i].clickeable_img : false
      sliders[i].title = data[i].tittle
      sliders[i].text = _p.fnReplaceTags(_p, data[i].text)
      sliders[i].buttons = []
      for (let j = 0; j < data[i].buttons.length; j++) {
        const btn = {}
        sliders[i].buttons.push(btn)
        btn.name = 'btn' + j
        btn.label = data[i].buttons[j].text
        btn.type = data[i].buttons[j].action
        btn.args = data[i].buttons[j].args
        btn.src = data[i].buttons[j]
        btn.readonly = readonly
        btn.event = function (evt) {
          _p.fnButtonEventGeneric(_p, sliders[0], evt)
        }
      }
    }
    sliders[0].processClick = !readonly
    _p.view.recieveMessage('slider-button', ts, sliders, commin) // _p.view.recieveMessage('slider-button', ts, sliders, commin.voice, _id)
  }

  /**
     *
     * Mensaje Botones  Inline
     *
     */
  renderButton (ts, commin, readonly = false, score) {
    const _p = this
    const data = commin
    const msg = {}
    msg.processClick = !readonly
    msg.image = data.image
    msg.title = data.tittle
    msg.text = _p.fnReplaceTags(_p, data.text)
    msg.clickeable_img = data.clickeable_img ? data.clickeable_img : false
    msg.buttons = []
    commin.score = score
    msg.notFeedback = (data.notFeedback) ? data.notFeedback : ''
    for (let i = 0; i < data.buttons.length; i++) {
      const btn = {}
      msg.buttons.push(btn)
      btn.name = 'btn' + i
      btn.label = data.buttons[i].text
      btn.type = data.buttons[i].action
      btn.args = data.buttons[i].args
      btn.src = data.buttons[i]
      btn.event = function (evt) {
        _p.fnButtonEventGeneric(_p, msg, evt)
      }
    }
    _p.view.recieveMessage('button', ts, [msg], commin) // _p.view.recieveMessage('button', ts, [msg], commin.voice, _id)
  }

  /**
     *
     * Mensaje Modal Inline
     *
     */
  renderModal (ts, commin, readonly = false) {
    const _p = this
    const data = commin.content
    const sliders = []
    for (let i = 0; i < data.length; i++) {
      sliders.push({})
      sliders[i].image = data[i].image
      sliders[i].title = data[i].tittle
      sliders[i].text = _p.fnReplaceTags(_p, data[i].text)
      sliders[i].buttons = []
      for (let j = 0; j < data[i].buttons.length; j++) {
        const btn = {}
        sliders[i].buttons.push(btn)
        btn.name = 'btn' + j
        btn.label = data[i].buttons[j].text
        btn.type = data[i].buttons[j].action
        btn.args = data[i].buttons[j].args
        btn.src = data[i].buttons[j]
        btn.readonly = readonly
        btn.event = function (evt) {
          _p.fnButtonEventGeneric(_p, sliders[0], evt)
        }
      }
    }
    sliders[0].processClick = !readonly
    _p.view.recieveMessage('slider-button', ts, sliders, commin) // _p.view.recieveMessage('slider-button', ts, sliders, commin.voice, _id)
  }

  /**
     *
     * Metodo para conectar a WS
     *
     */
  disconnect () {
    const _p = this
    _p.networkStatus = false
    if (_p.websocket) {
      log.info('GB: wss disconnect')
      _p.websocket.close(3001)
    }
  }

  /**
     *
     * Metodo para conectar a WS
     *
     */
  connect () {
    const _p = this
    _p.networkStatus = false

    // Evalua la conexion
    if (_p.websocket) {
      log.info('GB: wss release')
      _p.websocket.onopen = null
      _p.websocket.onclose = null
      _p.websocket.onerror = null
      _p.websocket.onmessage = null
      _p.websocket.close(3001)
    }
    log.info('GB: wss connect')
    _p.websocket = new WebSocket(_p.setup.websocket_url)

    // Habilita Input
    this.view.setInputText(true)

    // Primer evento de conexion
    _p.websocket.onopen = function () {
      log.info('GB: wss onopen')
      _p.reconnectSecs = 5
      if (_p.websocket) {
        _p.view.setInputText(true)
        _p.websocket.send(JSON.stringify({
          type: _p.setup.type,
          channel: _p.setup.channel,
          session_id: _p.setup.session_id
        }))
      } else {
        log.warn('GB: wss onopen null')
        _p.connect()
      }
    }

    // Perdida de conexion
    _p.websocket.onclose = function (evt) {
      _p.networkStatus = false
      _p.websocket = null
      if (evt.code === 3001) {
        log.warn('GB: wss onclose normal', evt.code, evt.data)
      } else {
        log.warn('GB: wss onclose error', evt.code, evt.data)
        _p.view.setInputText(false)
        _p.view.addChatSystem(today(), 'Conexión a servidor pérdida. Se intentará en ' + _p.reconnectSecs + ' segundos.')
        setTimeout(function () {
          if (utils.getCookie('gb-wbchtbt-isopen') === 'true') _p.connect()
        }, _p.reconnectSecs * 1000)
        _p.reconnectSecs += _p.reconnectSecs === 5 ? 5 : 10
      }
    }

    // Error en conexion
    _p.websocket.onerror = function (evt) {
      _p.networkStatus = false
      _p.websocket = null
      log.warn('GB: wss onerror', evt.readyState, evt.type)
    }

    // Mensaje Recibido
    this.websocket.onmessage = function (evt) {
      _p.networkStatus = true
      try {
        const datos = JSON.parse(evt.data)
        if (datos.type === 'config') {
          _p.eventConfig(datos)
        } else if (datos.type === 'init') {
          _p.eventInit(datos)
        } else if (datos.type === 'score') {
          _p.eventScore(datos)
        } else if (datos.type === 'system') {
          _p.view.addChatSystem(dayjs().format('HH:mm'), datos.data)
        } else if (datos.type === 'Typing') {
          _p.view.messageWaiting(true)
        } else if (datos.type === 'NotTyping') {
          _p.view.messageWaiting(false)
        } else if (datos.type === 'end' && _p.channel.plugin_pdf_save) {
          _p.eventDownloadConversation(datos)
        } else if (datos.type === 'DisableChatInput') {
          _p.view.setInputText(false)
        } else if (datos.type === 'EnableChatInput') {
          _p.view.setInputText(true)
        } else if (datos.type === 'negativefeed') {
          return
        } else if (datos.message && Array.isArray(datos.message)) {
          const _dts = []
          for (const i in datos.message) {
            _dts.push({
              origin: datos.origin,
              name: datos.name,
              time: datos.time,
              isBot: datos.isBot,
              message: datos.message[i]
            })
          }
          const arrItemMsg = _dts.slice()
          const interval = setInterval(function () {
            if (!arrItemMsg.length) {
              clearInterval(interval)
              _p.view.messageWaiting(false)
            } else {
              const itemMsg = arrItemMsg.shift()
              _p.eventMsgRx(itemMsg)
              if (arrItemMsg.length && typeof (itemMsg.message) !== 'function') _p.view.messageWaiting(true)
            }
          }, 1000)
        } else if (datos.message) {
          if (datos.origin === 'agent') datos.name = 'executive'
          _p.eventMsgRx(datos)
        } else log.warn('GB: onmessage ukn ', datos)
      } catch (e) {
        log.warn('GB: wss onmessage', evt.data, e)
      }
    }
  }

  /**
     *
     * Evento que recibe configuración
     *
     */
  eventConfig (datos) {
    const _p = this
    _p.enableChat = true

    // TODO: ajustes de preferencias
    _p.channel = datos.channel

    this.view.titleImageUrl = ''
    // this.view.placeholder = 'Cuéntame...'
    _p.view.participants = [{
      id: _p.channel.plugin_asistente_name,
      name: _p.channel.plugin_asistente_name,
      imageUrl: _p.channel.plugin_asistente_avatar
    }]

    this.view.enabledCloseBtn = _p.channel.closeLauncherEnabled

    /* Obtiene configuraciones de canal para pintar chat */
    if (!_p.channel.custom_avatars_plugin_enabled) {
      _p.view.title = _p.channel.plugin_asistente_name
      _p.view.subtitle = _p.channel.plugin_asistente_cargo
    }

    // Valida horario
    if (datos.channel.enabled && datos.channel.chat_enabled) {
      if (!datos.channel.chat_always_on) {
        let inTime = true
        if (datos.timeZoneOffSet) {
          inTime = false
        }

        if (!inTime) {
          _p.enableChat = false
          _p.view.addChatSystem(today(), 'Conversaciones no disponibles en este horario.')
        }
      }
    } else {
      _p.enableChat = false
      _p.view.addChatSystem(today(), 'Conversaciones desactivadas, tus mensajes serán ignorados.')
    }
    if (!_p.enableChat) return

    const external_data = {}
    if (_p.channel && _p.channel.company === 'simpli') {
      external_data.company = _p.channel.company
      external_data.companyID = window.localStorage.getItem('company_id')
    }

    // Envia Id cookie & Recupera información previa
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    _p.websocket.send(JSON.stringify({
      type: 'init',
      from_id: fromId,
      channel: _p.setup.channel,
      session_id: _p.setup.session_id,
      external_data: external_data
    }))
  }

  /**
     *
     * Evento que recibe inicialización
     * Datos de usuario y mensajes pasados
     *
     */
  eventInit (datos) {
    const _p = this
    /* Usuario no tuvo conversación anterior */
    // const data = sessionStorage.getItem('formLoginSkip')
    // if (data) return
    sessionStorage.setItem('formLoginSkip', true)
    _p.view.deleteChat()
    if ((datos.respuestaInit.messages.length === 0 || datos.respuestaInit.messages === undefined)) {
      // _p.view.deleteChat()
      let sesionValidate = false
      if (_p.setup.session_id === '') {
        sesionValidate = false
      } else {
        sesionValidate = true
      }
      if (_p.channel && _p.channel.plugin_mensaje_bienvenida) {
        _p.channel.plugin_mensaje_bienvenida = _p.channel.plugin_mensaje_bienvenida.replace('{{first_name}}', (sesionValidate && datos.respuestaInit.first_name) ? datos.respuestaInit.first_name : '').replace('{{last_name}}', (sesionValidate && datos.respuestaInit.first_name) ? datos.respuestaInit.first_name : '').replace(' .', '.')
      }
      /* Despliga formulario de ingreso de datos */
      if (_p.channel.plugin_enabled_input_name && !sesionValidate) {
        // _p.view.setCurrentForm('Login', { requerido: _p.channel.plugin_required_input_name, formMessage: _p.channel.plugin_message_login_form })
        _p.view.setCurrentForm('Login',
          {
            channelData: _p.channel,
            requerido: _p.channel.plugin_required_input_name,
            formMessage: _p.channel.plugin_message_login_form,
            formName: _p.channel.plugin_show_name,
            formMail: _p.channel.plugin_show_mail,
            formFone: _p.channel.plugin_show_fone,
            requeridoName: _p.channel.plugin_required_name,
            requeridoMail: _p.channel.plugin_required_mail,
            requeridoFone: _p.channel.plugin_required_fone
          })

        // _p.view.setFormNewData('Login', 'newdata', { requerido: _p.channel.plugin_required_input_name, formMessage: _p.channel.plugin_message_login_form });
        return
      } else {
        /* Despliega mensaje de bienvenida */
        if (_p.channel && _p.channel.plugin_mensaje_bienvenida && _p.channel.plugin_mensaje_bienvenida.length > 0) {
          let welcomeMessage
          try {
            welcomeMessage = JSON.parse(_p.channel.plugin_mensaje_bienvenida)
            // welcomeMessage.notFeedback = true;
          } catch (e) {
            welcomeMessage = _p.channel.plugin_mensaje_bienvenida
          }
          if (_p.channel.custom_webchat_messages) {
            const matchedCustomWebchatMessage = _p.channel.custom_webchat_messages.find((customWelcomeMessage) => { return _p.url.includes(customWelcomeMessage.url) })
            const customWebchatMessages = matchedCustomWebchatMessage
            if (customWebchatMessages && customWebchatMessages.messages) {
              if (this.chatOpenedByEvent) welcomeMessage = _p.processCustomWelcomeMessage(this.messageOpenedByEvent)
              customWebchatMessages.messages.forEach(message => {
              // Init Click en Chatbot
                if (message.type === 'init' && !this.chatOpenedByProactive && !this.chatOpenedByProactiveInmediate && !this.chatOpenedByEvent) {
                  welcomeMessage = _p.processCustomWelcomeMessage(message)
                }
                // Proactivo ejecución despues de un tiempo
                if (message.type === 'proactive') {
                  if (message.time === 0 && this.chatOpenedByProactiveInmediate && !this.chatOpenedByEvent) welcomeMessage = _p.processCustomWelcomeMessage(message)
                  else if (message.time > 0 && this.chatOpenedByProactive && !this.chatOpenedByEvent) welcomeMessage = _p.processCustomWelcomeMessage(message)
                }
                if (this.chatOpenedByEvent) welcomeMessage = _p.processCustomWelcomeMessage(this.messageOpenedByEvent)
              })
            }
          }
          _p.view.messageWaiting(true)
          setTimeout(function () {
            let messageDate = dayjs().utc()
            messageDate = messageDate.utcOffset(dayjs().utcOffset()).format('HH:mm')

            /* Reemplaza mensaje según tipo */
            if (welcomeMessage !== null && typeof welcomeMessage === 'object' && welcomeMessage.type === 'button') {
              _p.renderButton(messageDate, welcomeMessage, false, 0)
            } else if (welcomeMessage !== null && typeof welcomeMessage === 'object' && welcomeMessage.type === 'buttonslider') {
              _p.renderSliderButton(messageDate, welcomeMessage, false, 0)
            } else if (Array.isArray(welcomeMessage)) {
              for (const j in welcomeMessage) {
                const response_object = welcomeMessage[j]
                if (!response_object) {
                  continue
                }
                if (response_object.type === 'text') {
                  _p.view.addChat(messageDate, _p.fnReplaceTags(_p, response_object.text), response_object.voice, '0')
                } else if (response_object.type === 'button') {
                  _p.renderButton(messageDate, response_object, false, '0')
                } else if (response_object.type === 'buttonslider') {
                  _p.renderSliderButton(messageDate, response_object, false, '0')
                } else {
                  const sysMsg = utils.inputTypeToText(response_object)
                  if (sysMsg) _p.view.addChatSystem(messageDate, sysMsg)
                  else _p.view.addChatSystem(messageDate, 'Opción: Formulario')
                }
              }
            } else if (welcomeMessage !== null && typeof welcomeMessage === 'object' && welcomeMessage.type === 'text') {
              _p.view.addChat(messageDate, welcomeMessage.text, null, 0, welcomeMessage.notFeedback)
            } else {
              _p.view.addChat(messageDate, welcomeMessage, null, 0)
            }

            // Reproducir audio con mensaje de bienvenida
            if (_p.channel.plugin_enabled_audio) {
              const audio = new Audio(_p.channel.plugin_audio_sound)
              audio.play()
            }

            _p.view.messageWaiting(false)
          }, 1000)
        }
      }
    }
    // vienen datos de usuario
    _p.my.name = datos.respuestaInit.first_name
    _p.my.email = datos.respuestaInit.email
    _p.my.telefono = datos.respuestaInit.telefono
    // var ltime = 0;
    if (datos.respuestaInit.messages) {
      for (let i = 0; i < datos.respuestaInit.messages.length; i++) {
        let messageDate = dayjs(datos.respuestaInit.messages[i].creation_date).utc()
        messageDate = messageDate.utcOffset(dayjs().utcOffset())

        /*
              if (!ltime || dayjs.duration(messageDate.diff(ltime)).asHours() > 1) {
                  ltime = messageDate;
                  _p.view.addChatSystem(messageDate.format('DD-MM-YYYY HH:mm'), "");
              } */
        const _id = '0'
        // chat_user

        if (datos.respuestaInit.messages[i].manual_conversation !== true || datos.respuestaInit.messages[i].from_type === 'chat_user') {
          let _input = datos.respuestaInit.messages[i].input
          try {
            _input = JSON.parse(_input)
          } catch (e) {
            _input = { type: 'text', text: datos.respuestaInit.messages[i].input }
          }
          if (_input.type === 'text') {
            _p.view.addChatMe(messageDate.format('HH:mm'), _input.text, _id)
          } else if (_input.type && _input.type !== 'form-get-data') {
            const sysMsg = utils.inputTypeToText(_input)
            if (sysMsg) _p.view.addChatSystem(messageDate.format('HH:mm'), sysMsg)
          }
        }
        // bot or agent
        if (datos.respuestaInit.messages[i].manual_conversation !== true || datos.respuestaInit.messages[i].from_type === 'User') {
          let arr_response_object = datos.respuestaInit.messages[i].response_object ? datos.respuestaInit.messages[i].response_object : {}
          arr_response_object.chatId = datos.respuestaInit.messages[i]._id.split('').reverse().join('')
          if (datos.respuestaInit.messages[i].manual_conversation === true) {
            let raw_response_object
            try {
              raw_response_object = JSON.parse(datos.respuestaInit.messages[i].input)
            } catch (e) {
              raw_response_object = { type: 'text', text: datos.respuestaInit.messages[i].input }
            }
            arr_response_object = [raw_response_object]
          } else {
            if (!Array.isArray(arr_response_object)) {
              arr_response_object = [arr_response_object]
            }
          }
          for (const j in arr_response_object) {
            const response_object = arr_response_object[j]
            if (!response_object) {
              continue
            }
            response_object.score = datos.respuestaInit.messages[i].score
            if (response_object.type === 'text') {
              // _p.view.addChat(messageDate.format('HH:mm'), _p.fnReplaceTags(_p, response_object.text), response_object.voice, datos.respuestaInit.messages[i].score)
              _p.view.recieveMessage('text', messageDate.format('HH:mm'), response_object.text, response_object)
            } else if (response_object.type === 'button') {
              this.renderButton(messageDate.format('HH:mm'), response_object, false, datos.respuestaInit.messages[i].score)
            } else if (response_object.type === 'buttonslider') {
              this.renderSliderButton(messageDate.format('HH:mm'), response_object, false, _id)
            } else {
              const sysMsg = utils.inputTypeToText(response_object)
              if (sysMsg) _p.view.addChatSystem(messageDate.format('HH:mm'), sysMsg)
              else _p.view.addChatSystem(messageDate.format('HH:mm'), 'Opción: Formulario')
            }
          }
        }
      }
    }
  }

  /**
   * Add message to Chat
   * @param {Object} message
   * @returns {VoidFunction}
   */
  processCustomMessage (message) {
    const _p = this
    let messageDate = dayjs().utc()
    messageDate = messageDate.utcOffset(dayjs().utcOffset()).format('HH:mm')
    try {
      if (this.isJson(message.message.text)) {
        const parsedMessage = JSON.parse(message.message.text)
        if (parsedMessage.type === 'text') _p.view.addChat(messageDate, parsedMessage.text, false)
        else if (parsedMessage.type === 'button') _p.renderButton(messageDate, parsedMessage, false, 0)
        else if (parsedMessage.type === 'buttonslider') _p.renderSliderButton(messageDate, parsedMessage, false, 0)
      } else _p.view.addChat(messageDate, message.message.text, false)
    } catch (e) {
      _p.view.addChat(messageDate, message.message.text, false)
    }
  }

  /**
   * Receives a custom message and return text
   * @param {Object} message
   * @returns {String} text
   */
  processCustomWelcomeMessage (message) {
    let welcomeMessage
    try {
      welcomeMessage = JSON.parse(message.message.text)
      if (welcomeMessage.type === 'text') return welcomeMessage.text
      else return welcomeMessage
    } catch (e) {
      return this.isJson(message.message.text) ? JSON.parse(message.message.text) : message.message.text
    }
  }

  /**
     *
     * Valida si el string es un JSON
     *
     */
  isJson (txt) {
    let is_json = true
    try {
      JSON.parse(txt)
      if (!txt.match(new RegExp(/\[|\{/))) is_json = false
    } catch (e) {
      is_json = false
    }
    return is_json
  }

  /**
   *
   * @param {Object} message message
   * @param {Number} timeBetweenEvent desc
   * @param {String} messageDate desc
   * @returns
   */
  processCustomEventMessage (message, timeBetweenEvent, messageDate) {
    const _p = this
    const isOpenChat = utils.getCookie('gb-wbchtbt-isopen')
    if (dayjs() > _p.lastMessageTime.add(timeBetweenEvent, 'seconds')) {
      if (isOpenChat === 'false' || isOpenChat === '') {
        _p.view.openChat()
        _p.chatOpenedByEvent = true
        _p.messageOpenedByEvent = message
        return
      }
      _p.lastMessageTime = dayjs()
      try {
        if (this.isJson(message.message.text)) {
          const parsedMessage = JSON.parse(message.message.text)
          if (parsedMessage.type === 'text') _p.view.addChat(messageDate, parsedMessage.text, false)
          else if (parsedMessage.type === 'button') _p.renderButton(messageDate, parsedMessage, false, 0)
          else if (parsedMessage.type === 'buttonslider') _p.renderSliderButton(messageDate, parsedMessage, false, 0)
        } else _p.view.addChat(messageDate, message.message.text, false)
      } catch (e) {
        _p.view.addChat(messageDate, message.message.text, false)
      }
    }
  }

  /**
     *
     * Evento chat open
     *
     */
  eventchatOpened () {
    const _p = this
    log.info('GB Chat open')
    const screenWidthOpen = window.innerWidth
    if (screenWidthOpen < 576) {
      utils.setCookie('gb-wbchtbt-isopen', 'false', 365)
      utils.setCookie('gb-wbchtbt-minimize', 'true', 365)
    } else {
      utils.setCookie('gb-wbchtbt-isopen', 'true', 365)
      utils.setCookie('gb-wbchtbt-minimize', 'false', 365)
    }
    _p.reconnectSecs = RECONNECT_DEFAULT_SECS
    if (!_p.minimized) _p.connect()
  }

  /**
     *
     * Evento chat Close
     *
     */
  eventchatClosed (e, force = false) {
    const _p = this
    log.info('GB Chat close force', force)
    const current = _p.view.getCurrentForm()
    console.log(current)
    /* no cierra chat si login esta abierto */
    // if (_p.view.getCurrentForm() === 'Login') {
    //   const current = _p.view.getCurrentForm()
    //   console.log(current)
    //   return 'active'
    // }
    /* no cierra chat - solo minimiza chat */
    if (!force && _p.networkStatus === true && utils.getCookie('gb-wbchtbt-replies') === 'true') {
      _p.reconnectSecs = RECONNECT_DEFAULT_SECS
      _p.minimized = true // _p.disconnect();
      utils.setCookie('gb-wbchtbt-isopen', 'false', 365)
      utils.setCookie('gb-wbchtbt-minimize', 'true', 365)
      _p.view.hideCloseButton()
      return 'minimize'
    }
    /* no cierra chat si formulario esta abierto - se esconde formulario */
    // if (!force && _p.networkStatus === true && _p.view.getCurrentForm() !== '') {
    //   _p.view.setCurrentForm('')
    //   return 'active'
    // }
    /* Valores default al cerrar chat */
    utils.setCookie('gb-wbchtbt-replies', 'false')
    utils.setCookie('gb-wbchtbt-isopen', 'false', 365)
    utils.setCookie('gb-wbchtbt-minimize', 'false', 365)
    utils.setCookie('gb-wbchtbt-uid', utils.ObjectId(), 365)
    _p.view.setCurrentForm('')
    _p.view.deleteChat()
    _p.view.showCloseButton()
    _p.reconnectSecs = RECONNECT_DEFAULT_SECS
    /* Modo Embedded no cierra */
    if (_p.setup.embedded) {
      // AppAccelerator webview
      if (typeof Ti !== 'undefined') {
        // Ti.App.fireEvent('app:fromWebViewClose', { message: 'Close Event' });
      }
      // Android webview
      if (typeof Android !== 'undefined') {
        // Android.fromWebViewClose("Close Event");
      }
      // / iOS WkWebView
      if (typeof window.webkit !== 'undefined') {
        window.webkit.messageHandlers.fromWebViewClose.postMessage('Close Event')
      }
      return 'active'
    }
    /* Cierra es default */
    _p.disconnect()
    return 'close'
  }

  /**
     *
     * Evento que recibe nuevos mensajes salientes
     * para trasmitir para WS / UI
     *
     */
  eventMsgTx (originalMessage, originalHiddenMessage, isBackground) {
    const _p = this
    let watsonMessage
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const chatMessage = _p.textFromHtmlString(originalMessage)
    if (chatMessage && chatMessage.length > 15) watsonMessage = _p.procesarInput(chatMessage)
    else watsonMessage = chatMessage

    // LEVANTA LOGIN DESDE BOTON:
    if (originalHiddenMessage === 'client-open-form-login') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción inicio de sesión')
      _p.view.setCurrentForm('Login')
      return
    }

    if (originalHiddenMessage === 'client-close-formscore') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción de encuesta')
      _p.view.setCurrentForm('Score')
      _p.view.setFormNewData('Score', 'newdata', { step: 1 })
      return
    }
    if (originalHiddenMessage === 'client-score-conversation-form') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción de encuesta')
      _p.view.setCurrentForm('ScoreConversation')
      _p.view.setFormNewData('ScoreConversation', 'newdata', { step: 1 })
      return
    }

    if (originalHiddenMessage === 'client-close-no-formscore') {
      this.endWithoutScore()
      return
    }

    if (originalHiddenMessage === 'client-mail-sendconversation') {
      this.sendMail('conversation')
      return
    }

    const external_data = {}
    _p.lastActivity = (new Date()).getTime()
    if (!isBackground) _p.view.addChatMe(time(), chatMessage)
    if (_p.channel && _p.channel.company === 'simpli') {
      external_data.company = _p.channel.company
      external_data.companyID = window.localStorage.getItem('company_id')
    }
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      const dataToSend = {
        session_id: _p.setup.session_id,
        from_id: fromId,
        name: _p.my.name,
        email: _p.my.email,
        telefono: _p.my.telefono,
        message: watsonMessage,
        hiddenMessage: originalHiddenMessage,
        isBackground: isBackground,
        modo: _p.channel.plugin_chat_type,
        external_data: external_data
      }
      _p.websocket.send(JSON.stringify(dataToSend))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
  }

  /**
     *
     * Guarda contenido HTML en formato PDF
     *
     */
  html2pdf (strHtml, fileName) {
    utils.html2pdf(strHtml, fileName)
  }

  /**
     *
     * Evento que recibe nuevos mensajes entrantes
     * para mostrar en UI
     *
     */

  getVoice () {
    this.voces = window.speechSynthesis.getVoices()
  }

  eventMsgRx (datos) {
    const isBot = datos.isBot
    const voiceChat = window.protocol.channel.plugin_enable_voice_chat
    const voiceType = window.protocol.channel.plugin_voice_type
    this.getVoice()
    if (voiceChat === true && isBot) {
      // resproducir respuesta de texto a audio
      const textVoice = datos.message.text
      const modifyText = textVoice.replace(/<br>/g, '')
      const utterance = new SpeechSynthesisUtterance(modifyText)
      speechSynthesis.onvoiceschanged = this.getVoice
      utterance.voice = this.voces[voiceType]
      speechSynthesis.speak(utterance)
    }
    const _p = this
    let form = ''
    if (datos.name && datos.name.match(/tua/i) !== null && typeof (datos.message) === 'function') return
    if (window && window.sessionChatBot === false) {
      log.info('Cerrar chat')
      _p.view.closeChat(null, true)
      return
    }
    if (datos.origin === 'chat_user' && _p.setup && _p.setup.session_id && _p.setup.session_id.length > 50) {
      if (window && window.renovarSession && typeof window.renovarSession === 'function') {
        window.renovarSession(function (_sessionChatBot) {
          if (_sessionChatBot === false) {
            log.info('Cerrar chat por callback renovarSession')
            _p.view.closeChat(null, true)
          }
        })
      }
    }
    if (datos.origin !== 'chat_user' && datos.message.type !== 'action_result') {
      _p.view.messageWaiting(false)
    }

    if (datos.message.type === 'text') {
      _p.view.recieveMessage('text', time(), _p.fnReplaceTags(_p, datos.message.text), datos.message)
      // _p.view.recieveMessage('text', time(), _p.fnReplaceTags(_p, datos.message.text), datos.message.voice, datos.message.chatId)
    } else if (datos.message.type === 'buscarSucursalCercana') {
      utils.getLocation(function (loc) {
        if (loc) {
          // TODO: Validar si esto es un btn donde usuario confirma enviar enviar ubicacion.
          _p.view.addChatSystem(dayjs().format('HH:mm'), 'Enviando ubicación...')
          _p.eventMsgTx('Envío de ubicación', JSON.stringify({ type: 'action-nearest-branch', fields: { location: loc, entities: datos.message.entities, suc: 'cercana' } }), true)
        } else {
          _p.view.recieveMessage('text', time(), 'No es posible detectar la ubicación')
        }
      }, function (err) {
        log.info(err)
        _p.view.recieveMessage('text', time(), 'Debes permitir detectar la ubicación')
      })
    } else if (datos.message.type === 'buscarAnfitrionaCercana') {
      utils.getLocation(function (loc) {
        if (loc) {
          // TODO: Validar si estx|o es un btn donde usuario confirma enviar enviar ubicacion.
          _p.view.addChatSystem(dayjs().format('HH:mm'), 'Buscando a la anfitriona Club ALVI más cercana...')
          _p.eventMsgTx('Envío de ubicación', JSON.stringify({ type: 'action-nearest-hostess', fields: { location: loc, entities: datos.message.entities, suc: 'cercana' } }), true)
        } else {
          _p.view.recieveMessage('text', time(), 'No es posible detectar la ubicación')
        }
      }, function (err) {
        log.error(err)
        _p.view.recieveMessage('text', time(), 'Debes permitir detectar la ubicación')
      })
    } else if (datos.message.type === 'buscarSucursal') {
      const loc = {
        longitude: -33.5,
        latitude: -70.4
      }
      _p.eventMsgTx('Envío de ubicación', JSON.stringify({ type: 'action-nearest-branch', fields: { location: loc, entities: datos.message.entities } }), true)
    } else if (datos.message.type === 'html2pdf') {
      /* TODO: Mover a vista vue de tipo file */
      let content = '{{text}}<div class="espacio_iconos_tabla"><button class="va_iconos_tabla" onclick="window.protocol.html2pdf(\'{{content}}\',\'{{name}}\',\'pdf\')"><div class="va_icono_chat_fafa"><img src="https://chatbotqa.gatblac.com/static/multimedia/gatblac/icono-pdf.png"></img></div><p>Descargar</p></button></div>'
      content = content.replace(/{{text}}/g, datos.message.text)
        .replace(/{{content}}/g, datos.message.content)
        .replace(/{{name}}/g, datos.message.name)
      _p.view.recieveMessage('text', time(), content)
    } else if (datos.message.type === 'base64pdf') {
      /* TODO: Mover a vista vue de tipo file */
      let content = '{{text}}<div class="espacio_iconos_tabla"><button class="va_iconos_tabla" onclick="window.open(\'{{content}}\')"><div class="va_icono_chat_fafa"><img src="https://chatbotqa.gatblac.com/static/multimedia/gatblac/icono-pdf.png"></img></div><p>Descargar</p></button></div>'
      content = content.replace(/{{text}}/g, datos.message.text)
        .replace(/{{content}}/g, datos.message.content)
      _p.view.recieveMessage('text', time(), content)
    } else if (datos.message.type === 'base64img') {
      /* TODO: Mover a vista vue de tipo file */
      let content = '{{text}}<div class="espacio_iconos_tabla"><button class="va_iconos_tabla" onclick="window.open(\'{{content}}\')"><div class="va_icono_chat_fafa"><img src="https://biceqa.gatblac.com/static/multimedia/iconos/botones/click.png"></img></div><p>Descargar</p></button></div>'
      content = content.replace(/{{text}}/g, datos.message.text)
        .replace(/{{content}}/g, datos.message.content)
      _p.view.recieveMessage('text', time(), content)
    } else if (datos.message.type === 'buttonslider') {
      if (datos.message.chatId) this.renderSliderButton(time(), datos.message, false)
      else this.renderSliderButton(time(), datos.message, false, 0)
    } else if (datos.message.type === 'button') {
      if (datos.message.chatId) this.renderButton(time(), datos.message, false)
      else this.renderButton(time(), datos.message, false, 0)
    } else if (datos.message.type === 'form') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción inicio de sesión')
      _p.view.setCurrentForm('Login')
    } else if (datos.message.type === 'contact-form') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción Formulario Contacto')
      _p.view.setCurrentForm('ContactForm')
      _p.view.setFormNewData('ContactForm', 'newdata', datos.message)
    } else if (datos.message.type === '5f4697a061afb01ad9edf806-cotizar-form') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción Formulario Cotización')
      _p.view.setCurrentForm('CotizacionForm')
      _p.view.setFormNewData('CotizacionForm', 'newdata', datos.message)
    } else if (datos.message.type === '5f4697a061afb01ad9edf806-diaslibres-form') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción Formulario Días Libres')
      _p.view.setCurrentForm('DiasLibresForm')
      _p.view.setFormNewData('DiasLibresForm', 'newdata', datos.message)
    } else if (datos.message.type === 'chatbot-request-form') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción Formulario Solicitud de ChatBot')
      _p.view.setCurrentForm('GatblacNewChatbotRequest')
      _p.view.setFormNewData('GatblacNewChatbotRequest', 'newdata', datos.message)
    }
    /* POC ALVI */
    else if (datos.message.type === 'alvi-login-form') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción Formulario Contacto')
      _p.view.setCurrentForm('AlviLoginForm')
      _p.view.setFormNewData('AlviLoginForm', 'newdata', datos.message)
    } else if (datos.message.type === 'alvi-contacto-form') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción Formulario Contacto')
      _p.view.setCurrentForm('AlviContactoForm')
      _p.view.setFormNewData('AlviContactoForm', 'newdata', datos.message)
    }
    /* */
    else if (datos.message.type === 'form-get-data') {
      _p.view.setFormNewData(datos.message.form, 'updatedata', datos.message)
    } else if (datos.message.type === 'client-goodbye') {
      if (_p.channel.plugin_pdf_save) {
        this.endWithoutScore(datos)
      } else {
        this.endConversation()
      }
    } else if (datos.message.type === 'hubspot-calendar') {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Agendar hora')
      _p.view.showHubspotCalendarModal(datos.message.data)
    } else if (datos.message.type) {
      form = this.matchForms(_p.view.companyForms.forms, datos.message.type)
      this.setFormOnView(form, datos, _p.view.companyForms.forms)
    } else if (datos.origin !== 'chat_user') {
      datos.message = String(datos.message)
      if (_p.channel.plugin_notify_manualchat) {
        _p.view.recieveMessage('text', time(), datos.message, datos)
      } else {
        _p.view.recieveMessage('text', time(), datos.message)
      }
    }

    //
    /* Recuerda que se tiene una respuesta */
    utils.setCookie('gb-wbchtbt-replies', 'true')
    _p.lastActivity = (new Date()).getTime()

    // TODO: suggestions
    // TODO: mapa
  }

  /**
   * Función que se ejecutva al momento de que el usuario solicita un formulario y se encarga de hacer match el nombre del form con los seleccionados por compañía
   * @param {Array} companyForms
   * @param {String} formType
   * @returns Formulario
   */
  matchForms (companyForms, formType) {
    if (companyForms.length >= 1) {
      const form = companyForms.find((form) => form.type === formType)
      return form
    }
  }

  /**
   * Función que se encarga de levantar el formulario para el cliente en el webchat
   * @param {Object} form
   * @param {Object} datos
   */
  setFormOnView (form, datos, companyForms) {
    const _p = this
    if (form) {
      const formName = form.name
      const formOpenMessage = form.message.open
      _p.view.addChatSystem(dayjs().format('HH:mm'), formOpenMessage)
      _p.view.setCurrentForm(formName, {}, companyForms)
      _p.view.setFormNewData(formName, 'newdata', datos.message)
    }
  }

  eventScore (datos) {
    const _p = this
    if (datos.origin === 'bot') {
      return
    }
    if (datos.score === '0' && _p.channel.plugin_negative_feedback === true) {
      _p.view.setCurrentForm('NegativeFeedbackForm')
      _p.view.setFormNewData('NegativeFeedbackForm', 'newdata', datos)
    }
    if (datos.score === '1' && datos.endFeedback) {
      _p.view.addChatSystem(dayjs().format('HH:mm'), 'Opción de encuesta')
      _p.view.setCurrentForm('Score')
      _p.view.setFormNewData('Score', 'newdata', { step: 1, title: 'Evalúa mi atención como Ejecutivo' })
    }
    _p.websocket.send(JSON.stringify({
      type: 'score',
      chat_log_id: datos.chat_log_id,
      score: datos.score
    }))
  }

  eventChatbotOffDisplay () {
    const _p = this
    const cbo = JSON.parse(sessionStorage.getItem('chatbotOff'))
    const timeOff = cbo ? cbo.secondsOff : 60
    const tnow = (new Date()).getTime() - _p.lastActivity
    if (tnow > (timeOff * 1000)) {
      _p.showChatbot()
      sessionStorage.removeItem('chatbotOff')
    }
  }

  eventAutoClose () {
    const _p = this
    const autoclose = _p.channel ? (_p.channel.plugin_autoclose_time !== undefined && _p.channel.plugin_autoclose_time !== '' ? _p.channel.plugin_autoclose_time : 300) : 300
    const inactivity = _p.channel ? (_p.channel.plugin_inactivity_time !== undefined && _p.channel.plugin_inactivity_time !== '' ? _p.channel.plugin_inactivity_time : 90) : 90

    /*
        if (_p.setup && _p.setup.session_id && _p.setup.session_id.length > 50) {
            //no aplica fn en caso de uso de session_id obtenido desde anfitrion
            return;
        }
        */

    const tnow = (new Date()).getTime() - _p.lastActivity
    // Sin respuestas no hay actividad
    if (utils.getCookie('gb-wbchtbt-replies') !== 'true') {
      return
    }
    // 5 mins: se cierra automatico, para asegurar privacidad
    if (tnow > autoclose * 1000) {
      log.info('GB: eventAutoClose: cierre x seguridad transcurridos ', tnow)
      _p.lastActivity = (new Date()).getTime()
      if (_p.websocket && _p.channel) {
        _p.websocket.send(JSON.stringify({
          type: 'end',
          from_id: utils.getCookie('gb-wbchtbt-uid'),
          channel: _p.setup.channel,
          session_id: _p.setup.session_id,
          end_reason: 'end_by_inactivity_security',
          end_date: (new Date()).getTime()
        }))
      }
      _p.view.closeChat(null, true)
      return
    }
    // 90 seg sin actividad
    if (tnow > (inactivity * 1000) && _p.view.getCurrentForm() === '' && !closing) {
      if (_p.view.chatStatus !== 'active') {
        _p.view.openChat()
      }

      _p.view.setCurrentForm('Score')
      _p.view.setFormNewData('Score', 'newdata', { step: 0 })
    }
  }

  /**
     *
     * Evento que se recibe desde Formularios
     * Despacha a los metodos que contienen la
     * logica adecuada.
     *
     */

  formEvent (e) {
    const _p = this
    if (e.form === 'Score') _p.eventClickScoreSent(e)
    if (e.form === 'ScoreConversation') _p.eventClickScoreSent(e)
    if (e.form === 'Login') {
      if (e.evento === 'sentClick') _p.eventClickLoginSent(e)
      if (e.evento === 'cancelClick') _p.eventClickLoginCancel(e)
    }
    if (e.form === 'ContactForm') {
      if (e.evento === 'sentClick') _p.eventClickContactFormSent(e)
      if (e.evento === 'cancelClick') _p.eventClickContactFormCancel(e)
    }
    if (e.form === 'CotizacionForm') {
      if (e.evento === 'sentClick') _p.eventClickCotizacionFormSent(e)
      if (e.evento === 'cancelClick') _p.eventClickCotizacionFormCancel(e)
    }
    if (e.form === 'DiasLibresForm') {
      if (e.evento === 'sentClick') _p.eventClickDiasLibresFormSent(e)
      if (e.evento === 'cancelClick') _p.eventClickDiasLibresFormCancel(e)
    }
    if (e.form === 'GatblacNewChatbotRequest') {
      if (e.evento === 'sentClick') _p.eventClickChatbotRequestFormSent(e)
      if (e.evento === 'cancelClick') _p.eventClickChatbotRequestFormCancel(e)
    }
    if (e.form === 'NegativeFeedbackForm') {
      if (e.evento === 'sentClick') _p.eventNegativeFeedbackFormSent(e)
      if (e.evento === 'cancelClick') _p.eventClickNegativeFeedbackFormCancel(e)
    }
    if (e.form) {
      this.eventMatchForm(_p.view.companyForms.forms, e)
    }
  }

  /**
   * Función que compara el evento del formulario activado por el cliente con la lista de formularios disponibles por compañía
   * @param {Array} companyForms
   * @param {Object} e
   */
  eventMatchForm (companyForms, e) {
    const formName = e.form
    const formEvent = e.evento
    if (companyForms.length >= 1) {
      const form = companyForms.find((form) => form.name === formName)
      if (form) {
        if (formEvent === 'sentClick') {
          this.eventFormSend(e, form.message.send)
        } else if (formEvent === 'cancelClick') {
          this.eventFormCancel(formName)
        }
      }
    }
  }

  /**
   * Función que recibe los datos enviados desde el formulario y un mensaje para dejar registro en el webchat
   * @param {Object} datos
   * @param {String} message
   */
  eventFormSend (datos, message) {
    const _p = this
    log.info(`GB: ${message}`)
    const _d = datos.data
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: _d.type,
      fields: _d.fields
    }
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        name: _p.my.name,
        email: _p.my.email,
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: message,
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    // if (e.form === 'KrossNewClientForm') {
    //   if (e.evento === 'sentClick') _p.eventClickKrossNewClientFormSend(e)
    //   if (e.evento === 'cancelClick') _p.eventClickKrossNewClientFormCancel(e)
    // }
    // /* Naturaloe */
    // if (e.form === 'naturaloeContactForm' ||
    //   e.form === 'naturaloePurchaseProblemsForm' ||
    //   e.form === 'naturaloeChangeDeliveryAddressForm' ||
    //   e.form === 'naturaloeOrderStatusForm' ||
    //   e.form === 'naturaloeOrderProblemsForm') {
    //   if (e.evento === 'sentClick') _p.eventClickNaturaloeFormSent(e, e.form)
    //   if (e.evento === 'cancelClick') _p.eventClickNaturaloeFormCancel(e.form)
    // }
    // /* CACEM */
    // if (e.form === 'CacemContactForm') {
    //   if (e.evento === 'sentClick') _p.eventClickCacemContactFormSend(e)
    //   if (e.evento === 'cancelClick') _p.eventClickCacemContactFormCancel(e)
    // }

    // if (e.form === 'GatblacContactForm') {
    //   if (e.evento === 'sentClick') _p.eventClickGatblacContactFormSend(e)
    //   if (e.evento === 'cancelClick') _p.eventClickGatblacContactFormCancel(e)
    // }
    _p.view.setCurrentForm('')
  }

  /**
   * Función que recibe el nombre del formulario y se ejecuta al momento de cancelar el formulario
   * @param {String} formName
   */
  eventFormCancel (formName) {
    const _p = this
    log.info(`GB: Cancel ${formName}`)
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }

  /**
     * Score
     * Eventos del formulario
     *
     */
  eventClickScoreSent (datos) {
    const _p = this
    log.info('GB: eventClickScoreSent')

    if (datos.evento === 'algoMasSiClick') {
      _p.lastActivity = (new Date()).getTime()
      _p.view.setCurrentForm('')
      _p.view.addChatSystem(time(), 'Puedes seguir preguntándome')
      return
    }
    if (datos.evento === 'algoMasNoClick') {
      _p.lastActivity = (new Date()).getTime()
      if (_p.channel.plugin_enabled_survey) {
        _p.view.setCurrentForm('')
        _p.eventAnswerSurveyAsk()
      } else {
        closing = true
        _p.view.setCurrentForm('')
        if (_p.websocket && _p.channel) {
          _p.websocket.send(JSON.stringify({
            type: 'end',
            from_id: utils.getCookie('gb-wbchtbt-uid'),
            channel: _p.setup.channel,
            session_id: _p.setup.session_id,
            end_reason: 'end_by_conversation'
          }))
        }
        _p.view.setInputText(false)
        if (!_p.channel.plugin_pdf_save) {
          _p.view.closeChat(null, true); return
        } else {
          _p.view.addChatSystem(time(), 'Adjuntando conversación para su descarga...')
        }
        closing = false
      }
      return
    }

    if (datos.evento === 'omitirClick') {
      closing = true
      _p.view.setCurrentForm('')
      if (_p.websocket && _p.channel) {
        _p.websocket.send(JSON.stringify({
          type: 'end',
          from_id: utils.getCookie('gb-wbchtbt-uid'),
          channel: _p.setup.channel,
          session_id: _p.setup.session_id,
          end_reason: 'end_by_conversation'
        }))
      }
      _p.view.setInputText(false)
      if (!_p.channel.plugin_pdf_save) {
        _p.view.closeChat(null, true); return
      } else {
        _p.view.addChatSystem(time(), 'Adjuntando conversación para su descarga...')
      }
    }
    if (datos.evento === 'omitirClickScoreConversation') {
      _p.view.setCurrentForm('')
    }
    if (datos.evento === 'valorarClick') {
      _p.view.setCurrentForm('')
      _p.view.addChatSystem(time(), 'Calificación enviada. Gracias!')

      _p.view.setInputText(false)

      if (_p.websocket && _p.channel) {
        _p.websocket.send(JSON.stringify({
          type: 'end',
          from_id: utils.getCookie('gb-wbchtbt-uid'),
          channel: _p.setup.channel,
          session_id: _p.setup.session_id,
          score: datos.rating,
          score_option: datos.option,
          score_comment: datos.comments,
          end_reason: 'end_by_conversation_score'
        }))
      }

      _p.view.setInputText(false)
      if (_p.channel && _p.channel.company === 'simpli') _p.view.addChat(dayjs().format('HH:mm'), '¡Muchas Gracias! Me encanta conocer tu opinión.')
      else _p.view.addChat(dayjs().format('HH:mm'), 'Gracias por tu calificación, recuerda que me encuentro disponible para resolver tus dudas 24/7.')

      setTimeout(() => {
        _p.view.closeChat(null, true)
      }, 10000)

      if (_p.channel.plugin_pdf_save) {
        _p.view.addChatSystem(time(), 'Adjuntando conversación para su descarga...')
      }
    }
    if (datos.evento === 'valorarClickScoreConversation') {
      _p.view.setCurrentForm('')
      _p.view.addChatSystem(time(), 'Calificación enviada. Gracias!')

      // _p.view.setInputText(false)

      if (_p.websocket && _p.channel) {
        _p.websocket.send(JSON.stringify({
          type: 'scoreConversation',
          from_id: utils.getCookie('gb-wbchtbt-uid'),
          channel: _p.setup.channel,
          session_id: _p.setup.session_id,
          score: datos.rating,
          score_option: datos.option,
          score_comment: datos.comments
        }))
      }

      // _p.view.setInputText(false)
      _p.view.addChat(dayjs().format('HH:mm'), 'Gracias por tu calificación, recuerda que me encuentro disponible para responder tus dudas 24/7.')
    }
  }

  endWithoutScore () {
    const _p = this
    log.info('GB: endWithoutScore')
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    // _p.view.addChatSystem(dayjs().format('HH:mm'), "Iniciando formulario...");
    if (_p.websocket && _p.channel) {
      _p.websocket.send(JSON.stringify({
        type: 'end',
        from_id: fromId,
        channel: _p.setup.channel,
        session_id: _p.setup.session_id,
        score: 0,
        score_option: '',
        score_comment: '',
        end_reason: 'end_by_conversation_moscore'
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tus datos no han podido ser entregados.')
    }
    _p.view.setInputText(false)

    if (!_p.channel.plugin_pdf_save) {
      if (_p.channel && _p.channel.company === 'simpli') _p.view.addChat(dayjs().format('HH:mm'), '¡Muchas Gracias! Si necesitas más ayuda no dudes en hablarme nuevamente.')
      else _p.view.addChat(dayjs().format('HH:mm'), 'Muchas gracias por contactarte conmigo, recuerda que me encuentro disponible para resolver tus dudas 24/7.')
      setTimeout(() => {
        _p.view.closeChat(null, true)
      }, 10000)
    } else {
      _p.view.addChatSystem(time(), 'Adjuntando conversación para su descarga...')
    }
  }

  /**
     * Fin Conversación
     * Descarga Conversación
     *
     */
  eventDownloadConversation (datos) {
    const _p = this
    log.info('GB: eventDownloadConversation')
    _p.view.messageWaiting(true)
    setTimeout(() => {
      let content = `{{text}}
      <div class="sc-message--pdf-container">
        <img src="https://chatbotqa.gatblac.com/static/multimedia/gatblac/icono-pdf.png"></img>
        <button class="sc-message--download-button" onclick="window.open('{{content}}')">
          Descargar
        </button>
      </div>`
      content = content.replace(/{{text}}/g, datos.respuestaEnd.conversationPDF.text)
        .replace(/{{content}}/g, datos.respuestaEnd.conversationPDF.content)
        .replace(/{{name}}/g, datos.respuestaEnd.conversationPDF.name)

      const answer = {
        type: 'button',
        text: content,
        image: '',
        tittle: '',
        buttons: datos.respuestaEnd.conversationPDF.buttons,
        notFeedback: true
      }
      if (datos.respuestaEnd.conversationPDF.buttons && datos.respuestaEnd.conversationPDF.buttons.length > 0) this.renderButton(time(), answer, false, null)
      else _p.view.recieveMessage('text', time(), content)

      _p.view.messageWaiting(false)
    }, 3000)

    setTimeout(() => {
      _p.view.closeChat(null, true)
    }, 15000)
    // _p.view.refreshAvatar();
  }

  eventAnswerSurveyAsk () {
    const _p = this
    log.info('GB: eventAnswerSurveyAsk')
    _p.view.messageWaiting(true)
    const answer = {
      type: 'button',
      text: 'Espero haber respondido tu consulta.<br>Para seguir aprendiendo, por favor ¿podrías responder una breve encuesta?',
      image: '',
      tittle: '',
      buttons: [{
        action: 'text',
        text: 'Sí quiero',
        args: [
          'client-close-formscore'
        ]
      },
      {
        action: 'text',
        text: 'No quiero',
        args: [
          'client-close-no-formscore'
        ]
      }
      ]
    }
    this.renderButton(time(), answer, false, null)
    _p.view.setInputText(false)
    _p.view.messageWaiting(false)
  }

  /**
     * Fin Conversación
     * Envio de mail
     *
     */
  sendMail (type) {
    const _p = this
    log.info('GB: sendMail')

    const fromId = utils.getCookie('gb-wbchtbt-uid')
    if (type === 'conversation') {
      if (_p.websocket && _p.channel) {
        _p.websocket.send(JSON.stringify({
          type: 'sendmail-conversation',
          from_id: fromId,
          channel: _p.setup.channel,
          session_id: _p.setup.session_id
        }))
      } else {
        _p.view.addChatSystem(time(), 'Tus solicitud no ha podido ser procsada.')
      }
    }
  }

  /**
     * Login
     * Eventos del formulario
     *
     */
  eventClickLoginSent (datos) {
    const data = sessionStorage.getItem('formLoginSkip')
    if (!data) return
    sessionStorage.setItem('formOpen', true)
    const _p = this
    const _d = datos.data
    log.info('GB: eventClickLoginSent')
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: 'form-login',
      fields: {
        usuarioNombre: _d.usuario_nombre,
        usuarioMail: _d.usuario_mail,
        usuarioTelefono: _d.usuario_telefono
      }
    }
    _p.my.name = _d.usuario_nombre
    _p.my.email = _d.usuario_mail
    _p.my.telefono = _d.usuario_telefono

    // _p.view.addChatSystem(dayjs().format('HH:mm'), "");
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        first_name: _p.my.name,
        phone: _p.my.telefono,
        email: _p.my.email,
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: 'Iniciando Chat..',
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type,
        url: window.location.href
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }

    _p.view.setCurrentForm('')
  }

  eventClickLoginCancel () {
    const data = sessionStorage.getItem('formLoginSkip')
    if (!data) return
    const _p = this
    sessionStorage.setItem('formOpen', true)
    // sessionStorage.setItem('formLoginSkip', true)
    log.info('GB: eventClickLoginCancel')
    let welcomeMessage
    try {
      welcomeMessage = JSON.parse(_p.channel.plugin_mensaje_bienvenida)
    } catch (e) {
      if (_p.channel && _p.channel.plugin_mensaje_bienvenida) welcomeMessage = _p.channel.plugin_mensaje_bienvenida
      else welcomeMessage = 'Hola, soy un asistente virtual y estoy para ayudarte con tus consultas.<br>Cuéntame, ¿Qué necesitas?'
    }
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: 'form-login-skip',
      fields: {
      }
    }
    _p.my.name = ''
    _p.my.email = ''
    _p.my.telefono = ''
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: 'Iniciando Chat..',
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type,
        url: window.location.href
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    /*    _p.view.messageWaiting(true);
            setTimeout(function() {
                var messageDate = moment.utc();
                messageDate = messageDate.utcOffset(moment().utcOffset()).format('HH:mm');

                /* Reemplaza mensaje según tipo
                if (isObject(welcomeMessage) && welcomeMessage.type == "button")
                    _p.renderButton(messageDate, welcomeMessage, false, 0)
                else if (isObject(welcomeMessage) && welcomeMessage.type == "buttonslider")
                    _p.renderSliderButton(messageDate, welcomeMessage, false, 0)
                else _p.view.addChat(messageDate, welcomeMessage, null, 0);

                _p.view.messageWaiting(false);
            }, 1000);
            */
    _p.view.setCurrentForm('')
  }

  /**
     * CONTACT FORM
     * Eventos del formulario
     *
     */
  eventClickContactFormSent (datos) {
    const _p = this
    log.info('GB: eventClickContactoLynnSent')
    const _d = datos.data
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: 'contact-form',
      fields: _d.fields
    }
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: 'Envío Formulario de Contacto',
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    _p.view.setCurrentForm('')
  }

  eventClickContactFormCancel () {
    const _p = this
    log.info('GB: eventClickContactFormCancel')
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }

  /**
     * COTIZACION FORM
     * Eventos del formulario
     *
     */
  eventClickCotizacionFormSent (datos) {
    const _p = this
    log.info('GB: eventClickCotizacionFormSent')
    const _d = datos.data
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: '5f4697a061afb01ad9edf806-cotizar-form-confirm',
      fields: _d.fields
    }
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: 'Envío Formulario de Cotización',
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    _p.view.setCurrentForm('')
  }

  eventClickCotizacionFormCancel () {
    const _p = this
    log.info('GB: eventClickCotizacionFormCancel')
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }

  /**
     * DIAS LIBRES FORM
     * Eventos del formulario
     *
     */
  eventClickDiasLibresFormSent (datos) {
    const _p = this
    log.info('GB: eventClickDiasLibresFormSent')
    const _d = datos.data
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    if (_d.getData === true) {
      const hiddenmsg = { type: 'form-get-data', fields: { datatype: _d.datatype, form: _d.form, datos: _d.fields } }
      if (_p.websocket && _p.channel) {
        _p.websocket.send(JSON.stringify({
          session_id: _p.setup.session_id,
          from_id: fromId,
          name: _p.my.name,
          email: _p.my.email,
          message: 'Obteniendo días libres',
          hiddenMessage: JSON.stringify(hiddenmsg),
          isBackground: true,
          modo: _p.channel.plugin_chat_type
        }))
      } else {
        // TODO: entregar a vista mensaje
      }
    } else {
      const hiddenmsg = {
        type: '5f4697a061afb01ad9edf806-diaslibres-form',
        fields: _d.fields
      }
      if (_p.websocket && _p.channel) {
        _p.view.messageWaiting(true)
        _p.websocket.send(JSON.stringify({
          session_id: _p.setup.session_id,
          from_id: fromId,
          message: 'Envío Formulario de Días Libres',
          hiddenMessage: JSON.stringify(hiddenmsg),
          isBackground: false,
          modo: _p.channel.plugin_chat_type
        }))
      } else {
        _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
      }
      _p.view.setCurrentForm('')
    }
  }

  eventClickDiasLibresFormCancel () {
    const _p = this
    log.info('GB: eventClickDiasLibresFormCancel')
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }

  /**
     * CHATBOTREQUEST FORM
     * Eventos del formulario
     *
     */
  eventClickChatbotRequestFormSent (datos) {
    const _p = this
    log.info('GB: eventClickChatbotRequestFormSent')
    const _d = datos.data
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: _d.type,
      fields: _d.fields
    }
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: 'Envío Formulario de ChatBot Request',
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    _p.view.setCurrentForm('')
  }

  eventClickChatbotRequestFormCancel () {
    const _p = this
    log.info('GB: eventClickChatbotRequestFormCancel')
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }

  /**
     * UNIBAG
     * FORMULARIO DE COTIZAR
     */

  //  Wronganswer origin
  eventNegativeFeedbackFormSent (datos) {
    const _p = this
    log.info('GB: eventClickeventNegativeFeedbackFormSent')
    if (datos.origin === 'bot') {
      return
    }
    if (_p.websocket && _p.channel) {
      const dataToWss = JSON.stringify({
        type: 'negativefeed',
        chat_id: datos.chat_id,
        from_id: utils.getCookie('gb-wbchtbt-uid'),
        channel: _p.setup.channel,
        fields: datos.fields,
        session_id: _p.setup.session_id
      })
      _p.websocket.send(dataToWss)
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    _p.view.setCurrentForm('')
  }

  eventClickNegativeFeedbackFormCancel () {
    const _p = this
    log.info('GB: eventClickNegativeFeedbackFormCancel')
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }
  // #endregion

  changeSpanScore (chatlogId) {
    /* Reemplaza texto */
    const mensajesPuntuacion = document.querySelectorAll(
      'div[id="' + chatlogId + '"]'
    )
    // Para los casos de Respuestas en varios mensajes, estos al tener el mismo ID se usa querySelectorAll para obtener todos los
    // elementos, puesto que usar getElementById solo trae el primero. Despues, se recorre el arreglo y se encuentra el div en el que
    // estan almacenados los botones de Puntuacion.
    mensajesPuntuacion.forEach((mensajesPuntuacion) => {
      mensajesPuntuacion.children[0].childNodes[0].children[1].children[0].innerHTML = '<span class="calificacion-text">Calificación enviada.</span>'
    })
  }

  /**
     * Kross
     * FORMULARIO DE CLIENTE NUEVO
  */

  eventClickKrossNewClientFormSend (datos) {
    const _p = this
    log.info('GB: eventClickKrossNewClientFormSend')
    const _d = datos.data
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: _d.type,
      fields: _d.fields
    }
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        name: _p.my.name,
        email: _p.my.email,
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: 'Envío Formulario De Cliente nuevo',
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    _p.view.setCurrentForm('')
  }

  eventClickKrossNewClientFormCancel () {
    const _p = this
    log.info('GB: eventClickKrossNewClientFormCancel')
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }

  // #endregion

  /**
     * Naturaloe
     * Eventos formularios
  */
  eventClickNaturaloeFormSent (body, formName) {
    const _p = this
    log.info(`GB: eventClick${formName}Sent`)
    const _d = body.data
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: _d.type,
      fields: _d.fields
    }
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        name: _p.my.name,
        email: _p.my.email,
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: `Envío Formulario ${_d.title}`,
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    _p.view.setCurrentForm('')
  }

  eventClickNaturaloeFormCancel (formName) {
    const _p = this
    log.info(`GB: eventClickNaturaloe${formName}`)
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }
  // #endregion

  /**
     * CACEM
     * Eventos formularios
  */

  eventClickCacemContactFormSend (datos) {
    const _p = this
    log.info('GB: eventClickCacemContactFormSend')
    const _d = datos.data
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: _d.type,
      fields: _d.fields
    }
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        name: _p.my.name,
        email: _p.my.email,
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: 'Envío Formulario Contacto',
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    _p.view.setCurrentForm('')
  }

  eventClickCacemContactFormCancel () {
    const _p = this
    log.info('GB: eventClickCacemContactFormCancel')
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }

  eventClickGatblacContactFormSend (datos) {
    const _p = this
    log.info('GB: eventClickGatblacContactFormSend')
    const _d = datos.data
    const fromId = utils.getCookie('gb-wbchtbt-uid')
    const hiddenmsg = {
      type: _d.type,
      fields: _d.fields
    }
    if (_p.websocket && _p.channel) {
      _p.view.messageWaiting(true)
      _p.websocket.send(JSON.stringify({
        name: _p.my.name,
        email: _p.my.email,
        session_id: _p.setup.session_id,
        from_id: fromId,
        message: 'Envío Formulario Contacto',
        hiddenMessage: JSON.stringify(hiddenmsg),
        isBackground: false,
        modo: _p.channel.plugin_chat_type
      }))
    } else {
      _p.view.addChatSystem(time(), 'Tu mensaje no ha podido ser entregado.')
    }
    _p.view.setCurrentForm('')
  }

  eventClickGatblacContactFormCancel () {
    const _p = this
    log.info('GB: eventClickGatblacContactFormCancel')
    _p.view.addChat(dayjs().format('HH:mm'), 'Has cancelado la operación.<br>¿En que más te puedo ayudar?')
    _p.view.setCurrentForm('')
  }

  // #endregion

  /**
     *
     * Fn que extrae el texto formateado como html
     *
     */
  textFromHtmlString (arbitraryHtmlString) {
    const temp = document.createElement('div')
    temp.innerHTML = arbitraryHtmlString.replace(/<br>/g, '{{br}}')
    return temp.innerText.replace(/{{br}}/g, '<br>')
  }

  /**
     *
     * Fn para toggle
     *
     */
  toggle (idToggle, idImg) {
    const idToToggle = document.getElementById(idToggle)
    const idToChangeImg = document.getElementById(idImg)
    idToToggle.classList.toggle('va_tex_ultmov_vis')
    if (idToToggle.classList.value === 'va_tex_ultmov') {
      idToChangeImg.src = 'https://biceqa.gatblac.com/static/multimedia/iconos/botones/desplegar_abajo.png'
    } else {
      idToChangeImg.src = 'https://biceqa.gatblac.com/static/multimedia/iconos/botones/desplegar_arriba.png'
    }
  }

  /**
     *
     * Fn para elimnar hola en mensajes largos
     *
     */
  procesarInput (input) {
    // input = input.toLocaleLowerCase();
    input = input.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace('/t', '')
    /* const smalltalk_saludo = [
            'hola', 'buenos dias', 'buenas tardes', 'buenas noches', 'buenas'
        ];
         smalltalk_saludo.forEach(sm => {
              if (input.includes(sm)) {
                  input = input.replace(sm, '').trim()
              }
          }) */
    input = input.replace(/hola/i, '')
      .replace(/buenos dias/i, '')
      .replace(/buenas tardes/i, '')
      .replace(/buenas noches/i, '')
      .replace(/buenas/i, '').trim()
    return input
  }

  /**
   *
   * FN para campurar string y enviarlo como mensaje
   *
   */
  openChatWithText (inMsg, hiddenMessage = false) {
    const _p = this
    if (!inMsg || this.view.getCurrentForm() !== '') return

    this.view.openChat()
    setTimeout(function () {
      const intAutoChat = setInterval(function () {
        if (sessionStorage.getItem('gb-wbchtbt-isopen') === 'true') {
          _p.eventMsgTx(inMsg, undefined, hiddenMessage)
          clearInterval(intAutoChat)
        }
      }, 1000)
    }, 1500)
  }

  /**
     *
     * Fn para terminar chat
     *
     */
  endConversation () {
    const _p = this
    log.info('GB: endConversationEvent')

    _p.view.addChat(dayjs().format('HH:mm'), '¡Nos vemos! recuerda que estoy a tu disposición para atender tus dudas en todo momento.')
    setTimeout(() => {
      _p.view.closeChat(null, true)
    }, 3000)

    _p.view.refreshAvatar()
  }

  /**
   *
   * Fn que checkea si la sesion tiene la marca de chatbot oculto
   * Principalmente usado al recargar la pagina, valida si esta con la marca para mantenerse oculto
   *
   */
  checkChatbotOff () {
    const _p = this
    const sessionChatOff = JSON.parse(sessionStorage.getItem('chatbotOff'))
    if (sessionChatOff && sessionChatOff.off === true) {
      _p.hideChatbot(false)
    }
  }

  /**
   *
   * Fn que ocultar el chatbot
   *
   * @param {Boolean} setSession // true o null = Adicionalmente llama a la fn que setea el tiempo oculto || false = Oculta el chatbot por tiempo indefinido
   */

  hideChatbot (setSession) {
    const _p = this
    const chatbotElem = document.getElementById('gbChatbot')
    if (chatbotElem) chatbotElem.style.display = 'none'
    const closeLauncherBtnElem = document.getElementById('closeBtnItem')
    if (closeLauncherBtnElem) closeLauncherBtnElem.style.display = 'none'
    if (setSession !== false) {
      _p.setSessionChatbotOff(_p)
    }
  }

  /**
   * Fn que vuelve a mostrar el chatbot
   */

  showChatbot () {
    sessionStorage.removeItem('chatbotOff')
    const chatbotElem = document.getElementById('gbChatbot')
    if (chatbotElem) chatbotElem.style.display = ''
    const closeLauncherBtnElem = document.getElementById('closeBtnItem')
    if (closeLauncherBtnElem) closeLauncherBtnElem.style.display = ''
  }

  /**
   *
   * Fn que setea el tiempo en sessionStorage, tiempo que el chatbot debe mantenerse oculto
   * @param {Object} _p
   */

  setSessionChatbotOff (_p) {
    const obj = {
      off: true,
      secondsOff: _p.view.timeCloseBtn
    }
    sessionStorage.setItem('chatbotOff', JSON.stringify(obj))
  }

  /**
   * Fn que extrae session_id encriptado en portal de simpli + id de la compañia almacenado en localStorage
   */
  getAuthDivSimpli () {
    const simpliDiv = document.getElementById('authdiv')
    if (simpliDiv) {
      const companyID = window.localStorage.getItem('company_id')
      this.setup.session_id = `${simpliDiv.innerHTML.trim()}$${companyID}`
    }
  }
}
